import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import AffiliateAgreementModal from '../components/AffiliateAgreementModal';
import { Outlet, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { readAuthFromStorage, isRoleAllowed } from '../utils/auth';
import { fetchgetcheckbalance } from '../Redux/AdminSlices/withdrawrequestslice';
import { updateUserNdaUrl } from '../auth/authSlice';
import './MainLayout.css';
import '../branding/brand.css';

function MainLayout() {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [isSignedLocally, setIsSignedLocally] = useState(false);
    const [isAgreementModalOpen, setIsAgreementModalOpen] = useState(true);

    const { pathname } = useLocation();
    const hideSidebar = pathname.startsWith('/admin-grafana');
    const dispatch = useDispatch();

    const auth = useSelector((state) => state.auth);
    const checkbalancedata = useSelector((state) => state.withdrawrequest?.checkbalancedata);

    const storedAuth = readAuthFromStorage();
    const user = auth.user || storedAuth?.user;
    const role = auth.role || storedAuth?.role;

    const isAffiliate = isRoleAllowed(role, ['affiliate']);
    const userId = user?.user?.id || user?.id;

    // Trigger checkbalance if affiliate and checkbalancedata not yet loaded
    useEffect(() => {
        if (isAffiliate && userId && checkbalancedata === undefined) {
            dispatch(fetchgetcheckbalance(userId));
        }
    }, [isAffiliate, userId, checkbalancedata, dispatch]);

    // Check NDA status
    const userNdaUrl = user?.nda_url !== undefined ? user?.nda_url : user?.user?.nda_url;
    const balanceNdaUrl = checkbalancedata?.data?.nda_url;

    const isNdaSigned =
        isSignedLocally ||
        (typeof userNdaUrl === 'string' && userNdaUrl.trim().length > 0) ||
        (typeof balanceNdaUrl === 'string' && balanceNdaUrl.trim().length > 0);

    const isNdaPending =
        isAffiliate &&
        !isNdaSigned &&
        (userNdaUrl === null || balanceNdaUrl === null || userNdaUrl === undefined);

    const handleNdaSuccess = (signedUrl) => {
        setIsSignedLocally(true);
        setIsAgreementModalOpen(false);
        if (signedUrl) {
            dispatch(updateUserNdaUrl(signedUrl));
        }
        if (userId) {
            dispatch(fetchgetcheckbalance(userId));
        }
    };

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    return (
        <>
            <Navbar onToggleSidebar={hideSidebar ? undefined : toggleSidebar} />
            <div className={`main-layout-container${hideSidebar ? ' sidebar-hidden' : ''}${isNdaPending ? ' nda-locked' : ''}`}>
                {!hideSidebar && (
                    <>
                        <Sidebar isOpen={isSidebarOpen} onToggleSidebar={toggleSidebar} />
                        {isSidebarOpen && (
                            <div className="sidebar-overlay" onClick={toggleSidebar} aria-hidden="true" />
                        )}
                    </>
                )}
                <div className={`main-content-area${hideSidebar ? ' full-width' : ''}`}>
                    {isNdaPending ? (
                        <div className="nda-gate-lockout-screen">
                            <div className="nda-gate-card">
                                <div className="nda-gate-icon">
                                    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                                        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                                    </svg>
                                </div>
                                <div className="nda-gate-badge">Action Required</div>
                                <h2 className="nda-gate-title">Recruiter Agreement Required</h2>
                                <p className="nda-gate-desc">
                                    Before you can access your affiliate portal, client outreach, and earnings, you must review and digitally sign the Recruiter Agreement.
                                </p>
                                <button
                                    type="button"
                                    className="nda-gate-btn"
                                    onClick={() => setIsAgreementModalOpen(true)}
                                >
                                    Open Agreement &amp; Sign
                                </button>
                            </div>
                        </div>
                    ) : (
                        <Outlet />
                    )}
                </div>
            </div>

            {/* NDA Sign Modal: displayed by default after login when nda_url is null */}
            {isNdaPending && (
                <AffiliateAgreementModal
                    isOpen={isAgreementModalOpen}
                    onSuccess={handleNdaSuccess}
                />
            )}
        </>
    );
}

export default MainLayout;
